import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spin } from "antd";
import { getPortalEventDetail } from "services/portalEvents.service";
import { renderErrorNotifications } from "helpers/error.helpers";
import { mapEventDetailToCloneValues } from "../../../commons/events.helpers";
import CreateEvent from "../CreateEvent";

/**
 * Fetches the source event, strips its dates + schedules via mapEventDetailToCloneValues,
 * then mounts the standard CreateEvent form pre-seeded with those values.
 * No form/step/submit logic lives here — all of that is owned by CreateEvent.
 */
function CloneEvent() {
  const { eventId } = useParams();
  const navigate = useNavigate();
  const [seedValues, setSeedValues] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadSource() {
      const { data, errors } = await getPortalEventDetail(eventId);
      if (errors?.length > 0) {
        renderErrorNotifications(errors);
        navigate("/shoup-community/events");
        return;
      }
      setSeedValues(mapEventDetailToCloneValues(data));
      setLoading(false);
    }
    loadSource();
  }, [eventId, navigate]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: 400,
        }}
      >
        <Spin size="large" tip="Loading event for cloning…" />
      </div>
    );
  }

  return <CreateEvent seedValues={seedValues} />;
}

export default CloneEvent;
